import React, {useState, useContext, useEffect } from 'react';
import { Card, Row, Col, Button, Modal, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';
import PsContext from '../../../context';
import { PSListItem } from '../../../comp';
import { MDBInput } from 'mdb-react-ui-kit';
import API from '../../../utils/api';
import $ from 'jquery';
import axios from 'axios';


const EditAddress = (props) =>{
	
	const context = useContext(PsContext);
	const [adminCompany, setAdminCompany] = useState(false);
	const [editData, setEditData] = useState(false);
	const [validated, setValidated] = useState(false);
	const [btnLoading, setBtnLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [value, setValue] = useState('');
	

	
 	const handleSubmit = (event) => {
		event.preventDefault();
		try{
			setBtnLoading(true);
			API.post('v1/user/update',$("#frm_Edit").serialize()).then(res=>{
				if (res['data'].status == '1') {
				  toast.success("Customer Updated Successfully..!", "success");
				  document.getElementById("frm_Edit").reset();
				  setBtnLoading(false);
				  props.afterfinish();
				}
				else {
				  toast.error("Something Went Wrong..!", "danger");
				  document.getElementById("frm_Edit").reset();
				}
				setIsLoading(false);
			});
		}
		catch(error){
			
		}
	};
	
	return(
		<>
				<Form action="" method="post" id="frm_Edit" noValidate validated={validated} onSubmit={handleSubmit}>
				<input type="hidden" value={context.adminCompany.id} name="id" />
					<Row>
						<Col md={12} >
							<MDBInput 
								label="Address"
								type="text"
								name="address"
								id="address"
								required
								size="lg"
								defaultValue={context.adminCompany.address}
								
							 />
						</Col>
					</Row>
					<Row className="mt-4" >
						<Col md={12} >
							<MDBInput 
								label="City"
								type="text"
								name="city"
								id="city"
								required
								size="lg"
								defaultValue={context.adminCompany.city}
								
							 />
						</Col>
					</Row>
					<Row className="mt-4" >
						<Col md={12} >
							<MDBInput 
								label="Country"
								type="text"
								name="country"
								id="country"
								required
								size="lg"
								defaultValue={context.adminCompany.country}
								
							 />
						</Col>
					</Row>
					<Row className="mt-4" >
						<Col md={12} >
							<MDBInput 
								label="State"
								type="text"
								name="state"
								id="state"
								required
								size="lg"
								defaultValue={context.adminCompany.state}
								
							 />
						</Col>
					</Row>
					<Row className="mt-4" >
						<Col md={12} >
							<MDBInput 
								label="Pincode"
								type="text"
								name="pincode"
								id="pincode"
								required
								size="lg"
								defaultValue={context.adminCompany.pincode}
								
							 />
						</Col>
					</Row>
					<Row className="mt-4" >
						<Col md={12} >
							<Button
								type="submit"
								size="md"
								variant="success"
								className="btn-block"
								disabled={btnLoading}
							>
							{btnLoading ? 'Please wait..' : 'Update'}
							</Button>
						</Col>
					</Row>
				</Form>
		</>
	);
};
export default EditAddress;